/**
 * CAPTION IT — Product Page interactions
 *
 * - Live preview: scrivi il nome → si aggiorna in carte e scatola 3D
 * - Layer toggle: foto / carte / scatola
 * - Photo carousel: dots + auto-rotate ogni 5s su layer foto
 * - Variant radio: aggiorna prezzo CTA + classe attiva
 * - Tabs: descrizione / specifiche / spedizione / faq
 */
(function () {
  'use strict';

  /* Nomi che ruotano automaticamente nelle carte/box quando l'utente
     non ha ancora digitato nulla — comunica "è personalizzato" */
  const ROTATING_NAMES = ['MARCO', 'GIULIA', 'FRANCO', 'SARA', 'LUCA', 'ELENA'];
  const ROTATION_INTERVAL_MS = 2200;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function init() {
    const root = $('[data-ci-pdp]');
    if (!root) return;

    /* ---------- Live name preview ---------- */
    const nameInput = $('[data-ci-name-input]', root);
    const nameDisplays = $$('[data-ci-name-display]', root);

    let nameRotationTimer = null;
    let rotationIdx = 0;

    function setName(value) {
      const safe = (value || '').trim().slice(0, 30);
      const upper = (safe || ROTATING_NAMES[rotationIdx]).toUpperCase();
      nameDisplays.forEach(el => { el.textContent = upper; });
    }
    function startNameRotation() {
      stopNameRotation();
      if (!nameDisplays.length) return;
      nameRotationTimer = setInterval(() => {
        if (nameInput?.value.trim()) return; /* utente sta digitando, no rotation */
        rotationIdx = (rotationIdx + 1) % ROTATING_NAMES.length;
        nameDisplays.forEach(el => {
          el.classList.add('ci-name-fade');
          setTimeout(() => {
            el.textContent = ROTATING_NAMES[rotationIdx];
            el.classList.remove('ci-name-fade');
          }, 180);
        });
      }, ROTATION_INTERVAL_MS);
    }
    function stopNameRotation() {
      if (nameRotationTimer) { clearInterval(nameRotationTimer); nameRotationTimer = null; }
    }

    const hintEls = $$('[data-ci-name-hint]', root);
    if (nameInput) {
      nameInput.addEventListener('input', e => {
        setName(e.target.value);
        if (e.target.value.trim()) {
          stopNameRotation();
          hintEls.forEach(h => h.classList.add('ci-product__field-hint--active'));
        } else {
          startNameRotation();
        }
      });
      nameInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); }
      });
    }
    /* Avvia rotazione automatica al load (se nessun nome digitato) */
    if (!nameInput?.value.trim()) startNameRotation();
    /* Pausa rotazione su prefers-reduced-motion */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) stopNameRotation();

    /* Occasion select → updates box 3D tagline */
    const occasionInput = $('[data-ci-occasion-input]', root);
    const occasionDisplays = $$('[data-ci-occasion-display]', root);
    function setOccasion(value) {
      const text = (value || '').toLowerCase().trim();
      if (!text) return;
      const formatted = text + ' edition';
      occasionDisplays.forEach(el => { el.textContent = formatted; });
    }
    if (occasionInput) {
      occasionInput.addEventListener('change', e => setOccasion(e.target.value));
      /* Init con il valore corrente (default option) */
      setOccasion(occasionInput.value);
    }

    /* ---------- Hero layer toggle (photos / cards / box) ---------- */
    const layers = $$('[data-ci-pdp-layer]', root);
    const toggleButtons = $$('[data-ci-pdp-toggle]', root);
    const dotsContainer = $('[data-ci-pdp-dots]', root);
    let currentLayer = 'photos';

    function setLayer(layer) {
      currentLayer = layer;
      layers.forEach(l => l.classList.toggle('ci-pdp__layer--active', l.dataset.ciPdpLayer === layer));
      toggleButtons.forEach(b => {
        const active = b.dataset.ciPdpToggle === layer;
        b.classList.toggle('ci-pdp__hero-btn--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (dotsContainer) dotsContainer.style.visibility = layer === 'photos' ? 'visible' : 'hidden';
      /* Pausa tutti i video quando si esce dal layer photos */
      root.querySelectorAll('video').forEach(v => {
        if (layer === 'photos') {
          /* Riprendi solo il video della slide corrente */
          if (v.closest('.ci-pdp__photo--active')) v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }

    toggleButtons.forEach(btn => {
      btn.addEventListener('click', () => setLayer(btn.dataset.ciPdpToggle));
    });

    /* ---------- Photo carousel ---------- */
    const photos = $$('[data-ci-pdp-photo]', root);
    const dots = $$('[data-ci-pdp-dot]', root);
    let photoIdx = 0;
    let photoTimer = null;

    function setPhoto(idx) {
      if (!photos.length) return;
      photoIdx = ((idx % photos.length) + photos.length) % photos.length;
      photos.forEach((p, i) => {
        const active = i === photoIdx;
        p.classList.toggle('ci-pdp__photo--active', active);
        /* Auto play/pause video al cambio slide */
        const video = p.querySelector('video');
        if (video) {
          if (active) { video.play().catch(() => {}); }
          else { video.pause(); }
        }
      });
      dots.forEach((d, i) => d.classList.toggle('ci-pdp__hero-dot--active', i === photoIdx));
    }
    function isCurrentVideo() {
      return photos[photoIdx]?.dataset?.mediaType === 'video' ||
             photos[photoIdx]?.dataset?.mediaType === 'external_video';
    }
    function startAutoRotate() {
      stopAutoRotate();
      if (photos.length <= 1) return;
      photoTimer = setInterval(() => {
        /* Skip auto-advance se l'utente sta guardando un video */
        if (currentLayer === 'photos' && !isCurrentVideo()) setPhoto(photoIdx + 1);
      }, 5000);
    }
    function stopAutoRotate() {
      if (photoTimer) { clearInterval(photoTimer); photoTimer = null; }
    }
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        setPhoto(parseInt(dot.dataset.ciPdpDot, 10));
        stopAutoRotate();
      });
    });
    /* Frecce overlay: prev/next sul layer foto */
    const prevArrow = $('[data-ci-pdp-prev]', root);
    const nextArrow = $('[data-ci-pdp-next]', root);
    prevArrow?.addEventListener('click', e => {
      e.stopPropagation();
      setPhoto(photoIdx - 1);
      stopAutoRotate();
    });
    nextArrow?.addEventListener('click', e => {
      e.stopPropagation();
      setPhoto(photoIdx + 1);
      stopAutoRotate();
    });
    /* Pausa auto-rotate quando l'utente è inattivo */
    if (photos.length > 1) {
      const stage = $('[data-ci-pdp-stage]', root);
      stage?.addEventListener('mouseenter', stopAutoRotate);
      stage?.addEventListener('mouseleave', startAutoRotate);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!reduce.matches) startAutoRotate();
    }

    /* ---------- Variant selection (price update + active state) ---------- */
    const form = $('[data-ci-pdp-form]', root);
    const variantLabels = $$('[data-ci-variant]', root);
    /* Update TUTTI gli elementi prezzo (info area + sticky CTA mobile) */
    const priceEls = $$('[data-ci-pdp-price]', root);
    /* CTA elements: ora sono <a> (no più <button type=submit>) — selector aggiornato */
    const ctaEls = $$('[data-template]', root);
    /* Update label variante anche nella sticky bar */
    const stickyVariantEl = $('[data-ci-sticky-variant]', root);

    variantLabels.forEach(label => {
      const radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.addEventListener('change', () => {
        variantLabels.forEach(l => {
          const r = l.querySelector('input[type="radio"]');
          l.classList.toggle('ci-product__variant--active', r && r.checked);
          l.classList.toggle('ci-pdp__variant--active', r && r.checked);
        });
        const priceText = label.querySelector('.ci-product__variant-price, .ci-pdp__variant-price')?.textContent?.trim();
        priceEls.forEach(el => { if (priceText) el.textContent = priceText; });
        ctaEls.forEach(cta => {
          if (cta.dataset.template) {
            cta.firstChild.textContent = cta.dataset.template.replace('%PRICE%', priceText || '');
          }
        });
        if (stickyVariantEl) {
          const variantName = label.querySelector('.ci-product__variant-name, .ci-pdp__variant-name')?.textContent?.trim();
          if (variantName) stickyVariantEl.textContent = variantName;
        }
        /* Variant description toggle (da metafield custom.<variant_handle>) */
        const variantId = radio.value;
        $$('.ci-product__variant-desc[data-variant-id]', root).forEach(el => {
          el.hidden = el.dataset.variantId !== variantId;
        });
        /* Switch foto se la variante ha featured_media assegnata in admin */
        const photoIdxAttr = label.dataset.ciVariantPhoto;
        if (photoIdxAttr != null && photoIdxAttr !== '') {
          const idx = parseInt(photoIdxAttr, 10);
          if (!Number.isNaN(idx)) {
            /* Forza layer "photos" se siamo su cards/box */
            if (currentLayer !== 'photos') setLayer('photos');
            setPhoto(idx);
            stopAutoRotate();
          }
        }
      });
    });

    /* ---------- Cart link permalink — aggiorna href su change variante/proprietà ---------- */
    const cartLinks = $$('[data-ci-cart-link]', root);
    function updateCartLinks() {
      if (!form || !cartLinks.length) return;
      const fd = new FormData(form);
      const variantId = fd.get('id');
      if (!variantId) return;
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) {
        if (k === 'id' || k === 'quantity' || !v) continue;
        /* properties[X] → attributes[X] (cart permalink usa attributes) */
        const cleaned = k.replace(/^properties\[/, 'attributes[');
        params.append(cleaned, v);
      }
      params.append('return_to', '/checkout');
      const href = '/cart/' + variantId + ':1?' + params.toString();
      cartLinks.forEach(link => {
        /* Solo i bottoni di aggiunta al carrello (non quelli quiz) */
        if (link.dataset.ciPdpQuiz !== undefined) return;
        link.href = href;
      });
    }
    /* Update on form change (variant radio, text input, select) */
    form?.addEventListener('change', updateCartLinks);
    form?.addEventListener('input', updateCartLinks);
    /* Init at page load */
    updateCartLinks();

    /* ---------- Front card click → flip text from pool ---------- */
    const frontCard = $('[data-ci-cards-cycle]', root);
    if (frontCard) {
      const pool = (frontCard.dataset.cardPool || '').split('|').filter(Boolean);
      let cardIdx = 0;
      const textEl = frontCard.querySelector('[data-cycle-text]');
      frontCard.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!textEl || pool.length < 2) return;
        cardIdx = (cardIdx + 1) % pool.length;
        const nextText = pool[cardIdx]
          .replace(/%NAME%/g, '<span data-ci-name-display>' +
            (nameInput?.value.trim() || ROTATING_NAMES[rotationIdx] || 'MARCO').toUpperCase() +
          '</span>');
        /* Smooth flip: fade out, swap, fade in */
        frontCard.classList.add('ci-pdp__card--flipping');
        setTimeout(() => {
          textEl.innerHTML = nextText;
          frontCard.classList.remove('ci-pdp__card--flipping');
        }, 200);
      });
    }

    /* ---------- Quiz button (add to cart + redirect a mini quiz pre-acquisto) ---------- */
    const quizBtns = $$('[data-ci-pdp-quiz]', root);
    quizBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const f = form;
        if (!f) return;
        const url = btn.dataset.quizUrl || btn.getAttribute('href') || '/checkout';
        const originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'aggiungo…';
        try {
          const fd = new FormData(f);
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/json' }
          });
          if (!r.ok) {
            const err = await r.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'HTTP ' + r.status);
          }
          window.location.href = url;
        } catch (err) {
          alert('Errore: ' + (err.message || 'impossibile aggiungere al carrello'));
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      });
    });

    /* ---------- Tabs ---------- */
    const tabs = $$('[data-ci-tab]', root);
    const panels = $$('[data-ci-tab-panel]', root);
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.ciTab;
        tabs.forEach(t => {
          const active = t === tab;
          t.classList.toggle('ci-pdp__tab--active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(p => { p.hidden = p.dataset.ciTabPanel !== key; });
      });
    });

    /* ---------- Init ---------- */
    setLayer('photos');
    /* Forza la prima foto attiva. Il Liquid {% if forloop.first %} aggiunge
       già `--active` lato server, ma se Shopify CDN serve un cache vecchio
       o se per qualche motivo il marker manca, qui ce lo mettiamo a mano
       così le foto NON restano invisibili (opacity: 0 default). */
    if (photos.length) setPhoto(0);
    if (nameInput) setName(nameInput.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
